import { render, staticRenderFns } from "./DonationRegistration.vue?vue&type=template&id=f1ebf4a2&scoped=true"
import script from "./DonationRegistration.vue?vue&type=script&lang=js"
export * from "./DonationRegistration.vue?vue&type=script&lang=js"
import style0 from "./DonationRegistration.vue?vue&type=style&index=0&id=f1ebf4a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ebf4a2",
  null
  
)

export default component.exports